/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CandidatesSortByDto = {
    Date: 'DATE',
    ExternalProcessStatus: 'EXTERNAL_PROCESS_STATUS',
    FirstName: 'FIRST_NAME',
    LastName: 'LAST_NAME',
    Match: 'MATCH',
    OrdinalNumber: 'ORDINAL_NUMBER',
    Rate: 'RATE',
    Source: 'SOURCE',
    Status: 'STATUS'
} as const;

export type CandidatesSortByDto = typeof CandidatesSortByDto[keyof typeof CandidatesSortByDto];



